import {
  InstagramRadioButtonType,
  generateRadioButtonStageDefs,
} from './instagramRadioButtonUtils'
import { storySettingsUrl } from './instagramUrls'
import { InstagramSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { InstagramRecommendationKey } from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

const INITIAL_VALUES_SAVE_KEY = InstagramSettingKey.WHO_CAN_REPLY_TO_STORIES
const SECTION_LABEL = 'Who can reply to your stories'

enum CommentPrivacyLevel {
  EVERYONE = 'Everyone',
  PEOPLE_YOU_FOLLOW = 'People You Follow',
  OFF = 'Off',
  UNKNOWN = 'Unknown',
}

const TARGET_COMMENT_PRIVACY_LEVEL = CommentPrivacyLevel.PEOPLE_YOU_FOLLOW

function shouldUpdate(currentValue: CommentPrivacyLevel): boolean {
  // Don't update if is PEOPLE_YOU_FOLLOW or OFF
  return (
    CommentPrivacyLevel.EVERYONE === currentValue ||
    CommentPrivacyLevel.UNKNOWN === currentValue
  )
}

const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => value)
const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => !shouldUpdate(value))
const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

// Automations

enum StageKey {
  GATHER_STORY_REPLIES = 'GATHER_STORY_REPLIES',
  UPDATE_STORY_REPLIES = 'UPDATE_STORY_REPLIES',
  UNDO_STORY_REPLIES = 'UNDO_STORY_REPLIES',
}

const { gatherStageDefs, updateStageDefs, undoStageDefs } =
  generateRadioButtonStageDefs(
    InstagramRecommendationKey.INSTAGRAM_STORY_REPLIES,
    [INITIAL_VALUES_SAVE_KEY],
    () => SECTION_LABEL,
    () => TARGET_COMMENT_PRIVACY_LEVEL,
    shouldUpdate,
    StageKey.GATHER_STORY_REPLIES,
    StageKey.UPDATE_STORY_REPLIES,
    StageKey.UNDO_STORY_REPLIES,
    storySettingsUrl,
    InstagramRadioButtonType.Input,
  )

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
